import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { otherApiClient } from "src/api";
// === API 함수 ===
/**
 * 무료체험 자격 체크 API
 * 엔드포인트: GET /free-trial/check?productId={productId}
 */ export const checkFreeTrial = async (param)=>{
    let { productId  } = param;
    const { data  } = await otherApiClient.market("/free-trial/check", {
        params: {
            productId
        }
    });
    return data;
};
// === Query Keys ===
export const FREE_TRIAL_QUERY_KEYS = {
    check: (productId)=>[
            "freeTrial",
            "check",
            productId
        ]
};
/**
 * 상품의 무료체험 자격을 확인하는 훅
 * @param productId - 상품 ID
 * @param options - 쿼리 옵션
 *
 * @example
 * ```tsx
 * const { data, isLoading } = useFreeTrialCheck(productId)
 *
 * if (data?.isEligible) {
 *   // 무료체험 가능
 * }
 *
 * if (data?.reason === 'not_logged_in') {
 *   // 비로그인 상태 (로그인 후 무료체험 가능)
 * }
 * ```
 */ export const useFreeTrialCheck = (productId, options)=>{
    const { enabled =true  } = options !== null && options !== void 0 ? options : {};
    const router = useRouter();
    return useQuery({
        queryKey: FREE_TRIAL_QUERY_KEYS.check(productId !== null && productId !== void 0 ? productId : ""),
        queryFn: ()=>checkFreeTrial({
                productId: productId
            }),
        enabled: enabled && !!productId && router.isReady,
        // 무료체험 정보는 자주 변경되지 않으므로 5분간 캐시
        staleTime: 5 * 60 * 1000,
        retry: 1
    });
};
